// ==============================|| WIDGET - SATISFACTION CHART ||============================== //

const chartData = {
    height: 300,
    type: 'pie',
    options: {
        chart: {
            id: 'satisfaction-chart'
        },
        labels: ['Division 16', 'Division 18', 'Division 20', 'Division 22'],
        legend: {
            show: true,
            position: 'bottom',
            fontFamily: 'inherit',
            labels: {
                colors: 'inherit'
            }
        },
        dataLabels: {
            enabled: true,
            dropShadow: {
                enabled: false
            }
        },
        theme: {
            monochrome: {
                enabled: true
            }
        }
    },
    series: [4, 2, 2, 3]
};

export default chartData;
